export default __webpack_public_path__ + "static/myway-contact~cnIbzdpB-52b5f46b32dbd22bc184363c643b93bd.jpg";